import { WIX_INSTANCE_PARAMS } from '~actions/component_actions';
import axios from 'axios';
import { WidgetLoader } from '~loader/widget-loader';
import { isEmpty } from 'lodash';
import { Ticket } from 'widget/event_components/Ticket/index';
import { List, fromJS } from 'immutable';

export class TicketSpotContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      session: null,
      tickets: List(),
    };
  }

  async componentDidMount() {
    window.currency = this.props.event.get('currency');
    if (this.props.event.get('is_time_based')) {
      await this.getTimedOccurrences();
    } else if (this.props.settings.get('multiDayDateSelector') && this.props.event.get('is_series_event')) {
      await this.getRecurringSeries();
    } else {
      await this.createTickets();
    }
    await this.createSession();
  }

  async getTimedOccurrences() {
    const id = this.props.event.get('id');
    const url = `${process.env.EVENTVIEWER_SERVER}/api/v1/events/${id}/times${WIX_INSTANCE_PARAMS}`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.setState(
      {
        occurrences: fromJS(data),
      },
      () => {
        this.props.onResizeComponent && this.props.onResizeComponent();
      }
    );
  }
  async getRecurringSeries() {
    const id = this.props.event.get('id');
    const url = `${process.env.EVENTVIEWER_SERVER}/api/v1/events/${id}/occurrences${WIX_INSTANCE_PARAMS}`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.setState(
      {
        occurrences: fromJS(data),
      },
      () => {
        this.props.onResizeComponent && this.props.onResizeComponent();
      }
    );
  }

  async createSession() {
    const url = `${process.env.EVENTVIEWER_SERVER}/api/v1/sessions${WIX_INSTANCE_PARAMS}`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.setState(
      {
        session: data,
      },
      () => {
        this.props.onResizeComponent && this.props.onResizeComponent();
      }
    );
  }
  async createTickets() {
    const id = this.props.event.get('id');
    const url = `${process.env.EVENTVIEWER_SERVER}/api/v1/events/${id}/tickets${WIX_INSTANCE_PARAMS}`;
    const { data } = await axios.get(url, { withCredentials: true });

    this.setState(
      {
        tickets: fromJS(data),
      },
      () => {
        if (this.props.onResizeComponent) {
          setTimeout(() => {
            this.props.onResizeComponent();
          }, 2000);
        }
      }
    );
  }

  handleSessionDisconnect = async () => {
    const url = `${process.env.EVENTVIEWER_SERVER}/api/v1/sessions${WIX_INSTANCE_PARAMS}`;
    await axios.delete(url, { withCredentials: true });
    this.setState({
      session: { ...this.state.session, attendee: null, cards: null },
    });
  };

  render() {
    const isMobile = window.isMobileType;

    if (!this.state.session) {
      return <WidgetLoader loading={isEmpty(this.state.session)} isRelative />;
    }
    return (
      <div style={{ marginTop: isMobile ? 0 : 21, width: '100%' }}>
        <Ticket
          {...this.props}
          tickets={this.state.tickets}
          occurrences={this.state.occurrences}
          session={this.state.session}
          onSessionDisconnect={this.handleSessionDisconnect}
        />
      </div>
    );
  }
}
